import React, { useContext, useCallback, useEffect, useRef, useState, ReactNode } from 'react';
import { IPopoverContext } from './interfaces/IPopoverContext';
import { OpenPopoverProps, PopoverState } from './interfaces/PopoverState';
import { PopoverSizes } from './enums/PopoverSizes';
import PopoverContext from './context/PopoverContext';
import Popover from './components/Popover';

export const usePopover = (): IPopoverContext => useContext<IPopoverContext>(PopoverContext);

export { Popover, PopoverSizes };

interface IPopoverWindowProviderProps {
  children: ReactNode;
}

const PopoverWindowProvider = ({ children }: IPopoverWindowProviderProps): JSX.Element => {
  const popoverRef = useRef<HTMLDivElement>(null);
  const [popover, setPopover] = useState<PopoverState>({ isOpen: false, name: null, data: null });
  const [context, setContext] = useState<HTMLDivElement | null>();

  const openPopover = useCallback((props: OpenPopoverProps) => {
    setPopover({ isOpen: true, ...props });
  }, []);

  const closePopover = useCallback(() => {
    setPopover({ isOpen: false, name: null, data: null });
  }, []);

  useEffect(() => {
    setContext(popoverRef.current);
  }, []);

  return (
    <>
      <PopoverContext.Provider
        value={{
          popover,
          openPopover,
          closePopover,
          popoverNode: context,
        }}
      >
        {children}
      </PopoverContext.Provider>
      <div ref={popoverRef} />
    </>
  );
};

export default PopoverWindowProvider;
